import exp from "constants";
import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();
// Gets the logged in user data from local session

// Gets the logged in user data from local session
export const getLoggedUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedUser() !== null;
};

// Register Method
export const postRegister = (data: any) => api.create(url.POST_REGISTER, data);

// Login Method
export const postLogin = (data: any) => api.create(url.POST_LOGIN, data);

// Change Password
export const changePassword = (data: any) => api.create(url.POST_CHANGE_PASSWORD, data);

// Refresh Token
export const refreshToken = (data: string) => api.create(url.POST_REFRESH_TOKEN, data);

// postForgetPwd
export const postForgetPwd = (data: any) => api.create(url.POST_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data: any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postProfile = (data: any) => api.create(url.POST_EDIT_PROFILE, data);
// export const postProfile = (data: any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url: any, data: any) => {
  return api.create(url, data)
    .catch((err: any) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
// Login Method
export const postJwtLogin = (data: any) => api.create(url.POST_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data: any) => api.create(url.POST_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (data: any) => api.create(url.SOCIAL_LOGIN, data);

// Chat
export const getChat = (roomId: any) => api.get(`${url.GET_CHAT}/${roomId}`, { params: { roomId } });
export const addChat = (data: any) => api.create(url.ADD_CHAT, data);
export const deleteChat = (data: any) => api.delete(url.DELETE_CHAT, { headers: { data } });
export const bookmarkChat = (data: any) => api.delete(url.BOOKMARK_CHAT, { headers: { data } });


//Categories
export const getCategoryList = () => api.get(url.GET_CATEGORY_LIST, null);
export const addCategoryList = (data: any) => api.create(url.ADD_CATEGORY_LIST, data);
export const updateCategoryList = (data: any) => api.put(url.UPDATE_CATEGORY_LIST+ data.id, data);
export const deleteCategoryList = (data: any) => api.delete(url.DELETE_CATEGORY_LIST+data, data);
export const uploadCategoryImage = (data: any) => api.createWithFormData(url.POST_CATEGORY_IMAGE, data);


// City
export const getCity = () => api.get(url.GET_CITIES, null);
export const getStates = () => api.get(url.GET_STATES, null);
export const getDistricts = (param:string) => api.get(url.GET_DISTRICTS+param, null);
export const getCities = (param:string) => api.get(url.GET_CITIES+param, null);


// Brands
export const getBrands = () => api.get(url.GET_BRANDS, null);
export const getBrandByID = (id: any) => api.get(url.GET_BRANDS, id);
export const addBrand = (data: any) => api.create(url.ADD_BRANDS, data);
export const updateBrand = (data: any) => api.put(url.UPDATE_BRANDS + data.id, data);
export const deleteBrand = (data: any) => api.delete(url.DELETE_BRANDS+ data,data );
export const uploadBrandImage = (data: any) => api.createWithFormData(url.POST_BRAND_IMAGE, data);


//FAQS
export const getFAQList = () => api.get(url.GET_FAQ_LIST, null);
export const addFAQList = (data: any) => api.create(url.ADD_FAQ_LIST, data);
export const updateFAQList = (data: any) => api.put(url.UPDATE_FAQ_LIST+ data.id, data);
export const deleteFAQList = (data: any) => api.delete(url.DELETE_FAQ_LIST+data, data);

//CMS
export const getCMSList = () => api.get(url.GET_CMS_LIST, null);
export const addCMSList = (data: any) => api.create(url.ADD_CMS_LIST, data);
export const updateCMSList = (data: any) => api.put(url.UPDATE_CMS_LIST+ data.id, data);
export const deleteCMSList = (data: any) => api.delete(url.DELETE_CMS_LIST+data, data);


//USERS

export const getUsers = () => api.get(url.GET_USERS , null);
export const addUsers = (data: any) => api.create(url.ADD_USERS , data);
export const updateUsers = (data: any) => api.put(url.UPDATE_USERS + data.id, data);
export const deleteUsers = (data: any) => api.delete(url.DELETE_USERS +data, data);
export const getUsersById = () => api.get(url.GET_USERS_BY_ID , null);

//ROLES
export const getRoles = () => api.get(url.GET_ROLES , null);
export const addRoles = (data: any) => api.create(url.ADD_ROLES , data);
export const updateRoles =  (data: any) => api.put(url.UPDATE_ROLES + data.id, data);
export const deleteRoles = (data: any) => api.delete(url.DELETE_ROLES +data, data);
export const getRolesById =  () => api.get(url.GET_ROLES_BY_ID , null);
export const getUserRoles = () => api.get(url.GET_USER_ROLES , null);
export const getSalesRepresentatives = () => api.get(url.GET_SALES_REPRESENTATIVE , null);



//RESOURCES
export const getResources = () => api.get(url.GET_RESOURCES , null);
export const addResources = (data: any) => api.create(url.ADD_RESOURCES , data);
export const updateResources =  (data: any) => api.put(url.UPDATE_RESOURCES + data.id, data);
export const deleteResources = (data: any) => api.delete(url.DELETE_RESOURCES +data, data);

//PERMISSIONS
export const getPermissions = () => api.get(url.GET_PERMISSIONS , null);
export const addPermissions = (data: any) => api.create(url.ADD_PERMISSIONS , data);
export const updatePermissions =  (data: any) => api.put(url.UPDATE_PERMISSIONS + data.id, data);
export const deletePermissions = (data: any) => api.delete(url.DELETE_PERMISSIONS +data, data);


//Banner
export const getBannerList = () => api.get(url.GET_BANNER_LIST, null);
export const addBannerList = (data: any) => api.create(url.ADD_BANNER_LIST, data);
export const updateBannerList = (data: any) => api.put(url.UPDATE_BANNER_LIST+ data.id, data);
export const deleteBannerList = (data: any) => api.delete(url.DELETE_BANNER_LIST+data, data);
export const uploadBannerImage = (data: any) => api.createWithFormData(url.POST_BANNER_IMAGE, data);

//Coupon
export const getCouponList = () => api.get(url.GET_COUPON_LIST, null);
export const addCouponList = (data: any) => api.create(url.ADD_COUPON_LIST, data);
export const updateCouponList = (data: any) => api.put(url.UPDATE_COUPON_LIST+ data.id, data);
export const deleteCouponList = (data: any) => api.delete(url.DELETE_COUPON_LIST+data, data);


//Age Group
export const getAgeGroups = () => api.get(url.GET_AGE_GROUPS, null);
export const getProductSizes = () => api.get(url.GET_PRODUCT_SIZES, null);
export const getSeasons = () => api.get(url.GET_SEASONS, null);
export const getProductAttributes = () => api.get(url.GET_ATTRIBUTES, null);
export const getProductAttributeValues = (data:string) => api.get(url.GET_ATTRIBUTE_VALUES+data, null);
export const getPackagings = () => api.get(url.GET_PACKAGINGS, null);



// Ecommerce
// Orders
export const getOrders = () => api.get(url.GET_ORDERS, null);
export const getOrderById = (orderId: string) => api.get(url.GET_ORDER_BY_ID+orderId, null);
export const addOrders = (data: any) => api.create(url.ADD_ORDERS, data);
export const updateOrderStatus = (data: any) => api.create(url.UPDATE_ORDERS_STATUS, data);
export const deleteOrders = (data: any) => api.delete(url.DELETE_ORDERS, { headers: { data } });
export const getOrderStatusById = (orderId: string) => api.get(url.GET_ORDER_STATUS_BY_ID+orderId, null);
export const deleteOrderStatusById = (orderId: string) => api.delete(url.DELETE_ORDER_STATUS_BY_ID+orderId, null);
export const getMonthlyOrderCounts = () => api.get(url.GET_MONTHLY_ORDER_COUNTS, null);
export const getTotalOrderCounts = () => api.get(url.GET_TOTAL_ORDER_COUNTS, null);
export const cancelOrder = (orderId: string) => api.put(url.CANCEL_ORDER+orderId, {orderId: orderId});

// Carts
export const getCartSummary = () => api.get(url.GET_CART_SUMMARY, null);
export const getCarts = () => api.get(url.GET_CARTS, null);
export const getCartById = (userId: any, businessId:any) => api.get(url.GET_CART_BY_ID+userId+"/business/"+businessId,null);


// Wishlist
export const getWishlist = () => api.get(url.GET_WISHLIST, null);
export const getWishlistById = (userId: any, businessId:any) => api.get(url.GET_WISHLIST_BY_ID+userId+"/business/"+businessId,null);


// Wishlist
export const getUserProductHistory = () => api.get(url.GET_USER_PRODUCT_HISTORY, null);
export const getUserProductHistoryById = (userId: any) => api.get(url.GET_USER_PRODUCT_HISTORY_BY_ID+userId,null);



// Sellers
export const getSellers = () => api.get(url.GET_SELLERS, null);
export const addSellers = (data: any) => api.create(url.ADD_SELLERS, data);
export const updateSellers = (data: any) => api.update(url.UPDATE_SELLERS, data);
export const deleteSellers = (data: any) => api.delete(url.DELETE_SELLERS, { headers: { data } });

// Products
export const getProductList = () => api.get(url.GET_PRODUCT_LIST, null);
export const getProductById = (data:string) => api.get(url.GET_PRODUCT+data, null);
export const addProduct = (data: any) => api.create(url.ADD_PRODUCT, data);
export const updateProduct = (data: any) => api.put(url.UPDATE_PRODUCT+data.id, data);
export const deleteProduct = (data: any) => api.delete(url.DELETE_PRODUCT+data,  data);
export const uploadProductImages = (data: any) => api.createWithFormData(url.POST_PRODUCT_IMAGE, data);
export const addProductImages = (data: any) => api.create(url.ADD_PRODUCT_IMAGE, data);
export const deleteProductImages = (data: any) => api.delete(url.DELETE_PRODUCT_IMAGE+data, data);
export const getProductImages = (data: any) => api.get(url.GET_PRODUCT_IMAGES+ data, null);


// Product Variants
export const getProductVariants = () => api.get(url.GET_PRODUCT_VARIANTS, null);
export const getProductVariantById = (data:string) => api.get(url.GET_PRODUCT_VARIANT+data, null);
export const addProductVariant = (data: any) => api.create(url.ADD_PRODUCT_VARIANT, data);
export const updateProductVariant = (data: any) => api.put(url.UPDATE_PRODUCT_VARIANT+data.id, data);
export const deleteProductVariant = (data: any) => api.delete(url.DELETE_PRODUCT_VARIANT+data.id,data);


// Grid View
export const getProductGrid = () => api.get(url.GET_PRODUCT_GRID, null);
export const addProductGrid = (data: any) => api.create(url.ADD_PRODUCT_GRID, data);
export const updateProductGrid = (data: any) => api.update(url.UPDATE_PRODUCT_GRID, data);
export const deleteProductGrid = (data: any) => api.delete(url.DELETE_PRODUCT_GRID, { headers: { data } });

// Overview
export const getReview = () => api.get(url.GET_REVIEW, null);
export const addReview = (data: any) => api.create(url.ADD_REVIEW, data);
export const updateReview = (data: any) => api.update(url.UPDATE_REVIEW, data);
export const deleteReview = (data: any) => api.delete(url.DELETE_REVIEW, { headers: { data } });

// HR Management
// Employee List
export const getEmployee = () => api.get(url.GET_EMPLOYEE, null);
export const addEmployee = (data: any) => api.create(url.ADD_EMPLOYEE, data);
export const updateEmployee = (data: any) => api.update(url.UPDATE_EMPLOYEE, data);
export const deleteEmployee = (data: any) => api.delete(url.DELETE_EMPLOYEE, { headers: { data } });

// Holidays
export const getHolidays = () => api.get(url.GET_HOLIDAYS, null);
export const addHolidays = (data: any) => api.create(url.ADD_HOLIDAYS, data);
export const updateHolidays = (data: any) => api.update(url.UPDATE_HOLIDAYS, data);
export const deleteHolidays = (data: any) => api.delete(url.DELETE_HOLIDAYS, { headers: { data } });

// Leaves Manage

// Leave Manage (Employee)
export const getLeaveManageEmployee = () => api.get(url.GET_LEAVE_MANAGE_EMPLOYEE, null);

// Leave Manage (HR)
export const getLeaveManageHR = () => api.get(url.GET_LEAVE_MANAGE_HR, null);
export const addLeaveManageHR = (data: any) => api.create(url.ADD_LEAVE_MANAGE_HR, data);
export const updateLeaveManageHR = (data: any) => api.update(url.UPDATE_LEAVE_MANAGE_HR, data);
export const deleteLeaveManageHR = (data: any) => api.delete(url.DELETE_LEAVE_MANAGE_HR, { headers: { data } });

// Attendance
// Attendance (HR)
export const getAttendance = () => api.get(url.GET_ATTENDANCE, null);

// Main Attendance
export const getMainAttendance = () => api.get(url.GET_MAIN_ATTENDANCE, null);

// Departments
export const getDepartments = () => api.get(url.GET_DEPARTMENTS, null);
export const addDepartments = (data: any) => api.create(url.ADD_DEPARTMENTS, data);
export const updateDepartments = (data: any) => api.update(url.UPDATE_DEPARTMENTS, data);
export const deleteDepartments = (data: any) => api.delete(url.DELETE_DEPARTMENTS, { headers: { data } });

// Sales
// Estimates
export const getEstimates = () => api.get(url.GET_ESTIMATES, null);
export const addEstimates = (data: any) => api.create(url.ADD_ESTIMATES, data);
export const updateEstimates = (data: any) => api.update(url.UPDATE_ESTIMATES, data);
export const deleteEstimates = (data: any) => api.delete(url.DELETE_ESTIMATES, { headers: { data } });

// Payments
export const getPayments = () => api.get(url.GET_PAYMENTS, null);

// Expenses
export const getExpenses = () => api.get(url.GET_EXPENSES, null);
export const addExpenses = (data: any) => api.create(url.ADD_EXPENSES, data);
export const updateExpenses = (data: any) => api.update(url.UPDATE_EXPENSES, data);
export const deleteExpenses = (data: any) => api.delete(url.DELETE_EXPENSES, { headers: { data } });

// Payroll
// Employee Salary
export const getEmployeeSalary = () => api.get(url.GET_EMPLOYEE_SALARY, null);
export const addEmployeeSalary = (data: any) => api.create(url.ADD_EMPLOYEE_SALARY, data);
export const updateEmployeeSalary = (data: any) => api.update(url.UPDATE_EMPLOYEE_SALARY, data);
export const deleteEmployeeSalary = (data: any) => api.delete(url.DELETE_EMPLOYEE_SALARY, { headers: { data } });

// Notes
export const getNotes = () => api.get(url.GET_NOTES, null);
export const addNotes = (data: any) => api.create(url.ADD_NOTES, data);
export const updateNotes = (data: any) => api.update(url.UPDATE_NOTES, data);
export const deleteNotes = (data: any) => api.delete(url.DELETE_NOTES, { headers: { data } });

// Social
// Friends
export const getSocialFriends = () => api.get(url.GET_SOCIAL_FRIENDS, null);

// Events
export const getSocialEvent = () => api.get(url.GET_SOCIAL_EVENTS, null);
export const addSocialEvent = (data: any) => api.create(url.ADD_SOCIAL_EVENTS, data);
export const updateSocialEvent = (data: any) => api.update(url.UPDATE_SOCIAL_EVENTS, data);
export const deleteSocialEvent = (data: any) => api.delete(url.DELETE_SOCIAL_EVENTS, { headers: { data } });

// Invoices
export const getInvoiceList = () => api.get(url.GET_INVOICE_LIST, null);

// Users
// List View
export const getUserList = () => api.get(url.GET_USER_LIST, null);
export const addUserList = (data: any) => api.create(url.ADD_USER_LIST, data);
export const updateUserList = (data: any) => api.update(url.UPDATE_USER_LIST, data);
export const deleteUserList = (user: any) => api.delete(url.DELETE_USER_LIST, { headers: { user } });

// Grid View
export const getUserGrid = () => api.get(url.GET_USER_GRID, null);
export const addUserGrid = (data: any) => api.create(url.ADD_USER_GRID, data);
export const updateUserGrid = (data: any) => api.update(url.UPDATE_USER_GRID, data);
export const deleteUserGrid = (user: any) => api.delete(url.DELETE_USER_GRID, { headers: { user } });


//ATTRIBUTE
export const getAttributeList = () => api.get(url.GET_ATTRIBUTE_LIST, null);


//ATTRIBUTE VALUES
export const getAttribute = () => api.get(url.GET_ATTRIBUTE_LIST, null);
export const addAttributeList = (data: any) => api.create(url.ADD_ATTRIBUTE_LIST, data);
export const updateAttributeList = (data: any) => api.put(url.UPDATE_ATTRIBUTE_LIST+ data.id, data);
export const deleteAttributeList = (data: any) => api.delete(url.DELETE_ATTRIBUTE_LIST+data, data);



//ATTRIBUTE VALUES
export const getAttributeValue = () => api.get(url.GET_ATTRIBUTE_VALUE_LIST, null);
export const addAttributeValue = (data: any) => api.create(url.ADD_ATTRIBUTE_VALUE_LIST, data);
export const updateAttributeValue = (data: any) => api.put(url.UPDATE_ATTRIBUTE_VALUE_LIST+ data.id, data);
export const deleteAttributeValue = (data: any) => api.delete(url.DELETE_ATTRIBUTE_VALUE_LIST+data, data);

//PRODUCT SIZE
export const getProductSize = () => api.get(url.GET_PRODUCT_SIZE, null);
export const addProductSize = (data: any) => api.create(url.ADD_PRODUCT_SIZE, data);
export const updateProductSize = (data: any) => api.put(url.UPDATE_PRODUCT_SIZE+ data.id, data);
export const deleteProductSize = (data: any) => api.delete(url.DELETE_PRODUCT_SIZE+data, data);

//DISTRICT list
export const getDistrictList = () => api.get(url.GET_DISTRICT_LIST, null);
export const addDistrictList = (data: any) => api.create(url.ADD_DISTRICT_LIST, data);
export const updateDistrictList = (data: any) => api.put(url.UPDATE_DISTRICT_LIST+ data.id, data);
export const deleteDistrictList = (data: any) => api.delete(url.DELETE_DISTRICT_LIST+data, data);

//STATE 
export const getStateList = () => api.get(url.GET_STATE_LIST, null);

//CITY
export const getCityList = () => api.get(url.GET_CITY_LIST, null);
export const addCityList = (data: any) => api.create(url.ADD_CITY_LIST, data);
export const updateCityList = (data: any) => api.put(url.UPDATE_CITY_LIST+ data.id, data);
export const deleteCityList = (data: any) => api.delete(url.DELETE_CITY_LIST+data, data);

// User permisisons
export const getUserPermissions = (roleName:number) => api.get(url.GET_USER_PERMISSIONS+ roleName, null);

// Menus
export const getMenus = () => api.get(url.GET_MENUS, null);
export const addMenu = (data: any) => api.create(url.ADD_MENU, data);

export const addRoleMenu = (data: any) => api.create(url.ADD_ROLE_MENU, data);
export const getMenusByRole = (data: any) => api.get(url.GET_MENUS_BY_ROLE+data, null);


// unverified docs
export const getUnverifiedDocs = () => api.get(url.GET_UNVERIFIED_DOCS, null);
export const getBusiness = (status:string) => api.get(url.GET_BUSINESS+status, null);
export const getUnverifiedBusiness = () => api.get(url.GET_UNVERIFIED_BUSINESS, null);
export const getBusinessById = (businessId:string) => api.get(url.GET_BUSINESS_INFO+businessId, null);
export const getBusinessDocs = (businessId:string) => api.get(url.GET_BUSINESS_DOCS+businessId, null);


export const updateBusiness = (data: any) => api.put(url.UPDATE_BUSINESS_INFO+data.id, data);
export const updateDocStatusByBusiness = (data: any) => api.put(url.UPDATE_DOC_STATUS_BY_BUSINESS+data.id, data);
export const updateDocStatus = (data: any) => api.put(url.UPDATE_DOC_STATUS+data.id, data);

//Company
export const getCompany = () => api.get(url.GET_COMPANIES , null);
export const addCompany = (data: any) => api.create(url.ADD_COMPANIES , data);
export const updateCompany =  (data: any) => api.put(url.UPDATE_COMPANIES + data.id, data);
export const deleteCompany = (data: any) => api.delete(url.DELETE_COMPANIES +data, data);


//GSTRates
export const getGSTRates = () => api.get(url.GET_GTSRATES , null);
export const addGSTRates = (data: any) => api.create(url.ADD_GTSRATES , data);
export const updateGSTRates =  (data: any) => api.put(url.UPDATE_GTSRATES + data.id, data);
export const deleteGSTRates = (data: any) => api.delete(url.DELETE_GTSRATES +data, data);


export const getWeatherData = () => api.get(url.GET_WEATHER, null);

export const getTasks = () => api.get(url.GET_TASKS, null);
export const getTaskById = (taskId:any) => api.get(url.GET_TASK_BY_ID+taskId, null);
export const addTask = (data:any) => api.create(url.SAVE_TASK, data);
export const deleteTask = (data:any) => api.delete(url.DELETE_TASK + data.taskId, data);

export const getTaskStatus = () => api.get(url.GET_TASK_STATUS, null);
export const getTaskPriorities = () => api.get(url.GET_TASK_PRIORITIES, null);
export const getTaskUsers = () => api.get(url.GET_TASK_USERS, null);
export const getTaskComments = (taskId:number) => api.get(url.GET_TASK_COMMENTS+taskId, null);
export const addTaskComment = (data:any) => api.create(url.ADD_TASK_COMMENT, data);
export const deleteTaskComment = (data:any) => api.delete(url.DELETE_TASK_COMMENT + data.id, data);


export const getTaskDocuments = () => api.get(url.GET_TASK_DOCUMENTS, null);
export const addTaskDocument = (data: any) => api.create(url.ADD_TASK_DOCUMENT, data);
export const deleteTaskDocument = (data: any) => api.delete(url.DELETE_TASK_DOCUMENT , data);



//File
export const getFileList = () => api.get(url.GET_FILE_LIST, null);
export const addFile = (data: any) => api.create(url.ADD_FILE, data);
export const updateFile = (data: any) => api.put(url.UPDATE_FILE + data.id, data);
export const deleteFile = (data: any) => api.delete(url.DELETE_FILE+data, data);
export const uploadFiles = (data: any) => api.createWithFormData(url.UPLOAD_DOCS, data);

// Vendors

//File
export const getVendorList = () => api.get(url.GET_VENDORS, null);
export const saveVendor = (data: any) => api.create(url.SAVE_VENDOR, data);
export const deleteVendor = (data: any) => api.delete(url.DELETE_VENDOR+data, data);
export const uploadVendorFiles = (data: any) => api.createWithFormData(url.UPLOAD_DOCS, data);
export const notifyContract = (data: any) => api.get(url.NOTIFY_CONTRACT+data.vendorId, null);

// Warehouses
export const getWarehouseList = () => api.get(url.GET_WAREHOUSES, null);
export const getWarehouseById = (warehouseId: any) => api.get(url.GET_WAREHOUSE_BY_ID + warehouseId, null);
export const addWarehouse = (data: any) => api.create(url.ADD_WAREHOUSE, data);
export const updateWarehouse = (data: any) => api.put(url.UPDATE_WAREHOUSE + data.id, data);
export const deleteWarehouse = (data: any) => api.delete(url.DELETE_WAREHOUSE+data, data);

// Racks
export const getRackList = () => api.get(url.GET_RACKS, null);
export const getRackById = (rackId: any) => api.get(url.GET_RACK_BY_ID + rackId, null);
export const addRack = (data: any) => api.create(url.ADD_RACK, data);
export const updateRack = (data: any) => api.put(url.UPDATE_RACK + data.id, data);
export const deleteRack = (data: any) => api.delete(url.DELETE_RACK+data, data);

// Bins
export const getBinList = () => api.get(url.GET_BINS, null);
export const getBinById = (binId: any) => api.get(url.GET_BIN_BY_ID + binId, null);
export const addBin = (data: any) => api.create(url.ADD_BIN, data);
export const updateBin = (data: any) => api.put(url.UPDATE_BIN + data.id, data);
export const deleteBin = (data: any) => api.delete(url.DELETE_BIN+data, data);

// Item Groups
export const getItemGroupList = () => api.get(url.GET_ITEM_GROUPS, null);
export const getItemGroupById = (itemGroupId: any) => api.get(url.GET_ITEM_GROUP_BY_ID + itemGroupId, null);
export const addItemGroup = (data: any) => api.create(url.ADD_ITEM_GROUP, data);
export const updateItemGroup = (data: any) => api.put(url.UPDATE_ITEM_GROUP + data.id, data);
export const deleteItemGroup = (data: any) => api.delete(url.DELETE_ITEM_GROUP+data, data);

// Items
export const getItemList = () => api.get(url.GET_ITEMS, null);
export const getItemById = (itemId: any) => api.get(url.GET_ITEM_BY_ID + itemId, null);
export const addItem = (data: any) => api.create(url.ADD_ITEM, data);
export const updateItem = (data: any) => api.put(url.UPDATE_ITEM + data.id, data);
export const deleteItem = (data: any) => api.delete(url.DELETE_ITEM+data, data);

// Pantone Colors
export const getPantoneColorList = () => api.get(url.GET_PANTONE_COLORS, null);
export const getPantoneColorById = (pantoneColorId: any) => api.get(url.GET_PANTONE_COLOR_BY_ID + pantoneColorId, null);
export const addPantoneColor = (data: any) => api.create(url.ADD_PANTONE_COLOR, data);
export const updatePantoneColor = (data: any) => api.put(url.UPDATE_PANTONE_COLOR + data.id, data);
export const deletePantoneColor = (data: any) => api.delete(url.DELETE_PANTONE_COLOR+data, data);

// Item RGB Color Stock
export const getItemRgbColorStockList = () => api.get(url.GET_ITEM_RGB_COLOR_STOCK, null);
export const getClosestLabColors = (data: any) => api.create(url.GET_CLOSEST_LAB_COLORS, data);
export const getClosestHexColors = (data: any) => api.create(url.GET_CLOSEST_HEX_COLORS, data);

// Item Stock
export const getItemStockList = () => api.get(url.GET_ITEM_STOCKS, null);
export const getItemStockById = (itemStockId: any) => api.get(url.GET_ITEM_STOCK_BY_ID + itemStockId, null);
export const addItemStock = (data: any) => api.create(url.ADD_ITEM_STOCK, data);
export const updateItemStock = (data: any) => api.put(url.UPDATE_ITEM_STOCK + data.id, data);
export const deleteItemStock = (data: any) => api.delete(url.DELETE_ITEM_STOCK+data, data);


//Annoucement
export const getAnnouncementList = () => api.get(url.GET_ANNOUNCEMENT, null);
export const getAnnouncementById = (announcementId:any) => api.get(url.GET_ANNOUNCEMENT_BY_ID + announcementId, null);
export const saveAnnouncement = (data: any) => api.create(url.SAVE_ANNOUNCEMENT, data);
// export const updateAnnouncementList = (data: any) => api.put(url.UPDATE_ANNOUNCEMENT_LIST+ data.id, data);
export const deleteAnnouncement = (data: any) => api.delete(url.DELETE_ANNOUNCEMENT+data, data);

//Public Announcement
export const getPublicAnnouncements = () => api.get(url.GET_ANNOUNCEMENT_PUBLIC, null);
export const getPublicAnnouncementById = (announcementId:any) => api.get(url.GET_ANNOUNCEMENT_PUBLIC_BY_ID + announcementId, null);

// Complaints
export const getComplaints = () => api.get(url.GET_COMPLAINTS, null);
export const getComplaintById = (complaintId:any) => api.get(url.GET_COMPLAINTS + complaintId, null);
export const addComplaint = (data:any) => api.create(url.ADD_COMPLAINT, data);
export const updateComplaint = (data:any) => api.put(url.UPDATE_COMPLAINT + data.id, data);
export const deleteComplaint = (data:any) => api.delete(url.DELETE_COMPLAINT + data.id, data);
export const getComplaintStatus = () => api.get(url.GET_COMPLAINT_STATUS, null);
export const getComplaintPriorities = () => api.get(url.GET_COMPLAINT_PRIORITIES, null);
export const getComplaintCategories = () => api.get(url.GET_COMPLAINT_CATEGORIES, null);
export const getComplaintLocations = () => api.get(url.GET_COMPLAINT_LOCATIONS, null);
export const getComplaintComments = (complaintId:number) => api.get(url.GET_COMPLAINT_COMMENTS + complaintId, null);
export const addComplaintComment = (data:any) => api.create(url.ADD_COMPLAINT_COMMENT, data);
export const deleteComplaintComment = (data:any) => api.delete(url.DELETE_COMPLAINT_COMMENT + data.id, data);

// Dashboard
export const getDashboardData = (userId:number) => api.get(url.GET_DASHBOARD_DATA, null);

// Pest Control
export const getPestControlList = () => api.get(url.GET_PEST_CONTROL_LIST, null);
export const addPestControl = (data:any) => api.create(url.ADD_PEST_CONTROL, data);
export const deletePestControl = (data:any) => api.delete(url.DELETE_PEST_CONTROL + data.pestControlId, data);
export const sendPestControlEmail = (data:any) => api.get(url.SEND_PEST_CONTROL_EMAIL + data.pestControlId + "&residentId=1" , null);

